import memoizeOne from 'react-utils/memoizeOne';
import { getProjectName, getWindow } from '../../../common/utils';
export const getGrowGuideQueryParams = memoizeOne(() => {
  const currentWindow = getWindow();
  const appName = getProjectName();
  return {
    href: currentWindow.location.href,
    appName,
    title: currentWindow.document.title,
    pathname: currentWindow.location.pathname
  };
});